import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettAnimalCoat } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxSnackbar from '../../cx/CxSnackbar';


const MxSettAnimalCoatForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();
  const r_snack_record_used = React.useRef(null);

  let r_form = React.useRef(null);

  const [storeSettAnimalCoat, setStoreSettAnimalCoat] = useSessionStorage('StoreSettAnimalCoat', StoreSettAnimalCoat);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
    } else {
      storeSettAnimalCoat.itAnimalCoat = lastSaveRv.theValue;
      Promise.all([setStoreSettAnimalCoat(storeSettAnimalCoat)]).then((result) => {
        navBack();
      });
    }
  }
  const formDelete = async (rv) => {
    if (rv.theValue==='rv_error') {
      r_snack_record_used.current.setOpen(true);
    }
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.patients')}: ${trans('field.coat')}`}
        xref={r_form}
        url="sett/animal_coat" 
        filterIdField='itAnimalCoat'
        filterIdValue={storeSettAnimalCoat.itAnimalCoat} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="t_animal_coat.itAnimalCoat" value={storeSettAnimalCoat.itAnimalCoat || ''} />
        <CxInput xref={useRef(null)} label={trans('field.coat')} dbfield="t_animal_coat.txTypeAnimalCoat" required />
        
      </GxForm>

      <CxSnackbar xref={r_snack_record_used} severity="error" value={trans('msg.record_used')} />

    </div>
  );

}

export default MxSettAnimalCoatForm;
